module.exports = __webpack_public_path__ + "img/hero-illustration-v2.412e164d.svg";